import { Construtor } from './construtor';
import { StringValidacao } from './string';

export class Processo implements Construtor<Processo> {

    public idProcesso: number;
    public nomeProcesso: string;
    public siglaProcesso: string;
    public selecionado: boolean;

    constructor(object?: any) {

        this.selecionado = false;

        if (object !== undefined) {

            if (object instanceof (Processo)) {
                this.copyObject(object);
            } else {
                this.parseFromJson(object);
            }

            if (!this.modeloCompleto()) {
                return null;
            }
        }
    }

    set IdProcesso(idProcesso: any) {
        this.idProcesso = idProcesso;
    }

    set NomeProcesso(nomeProcesso: any) {
        this.nomeProcesso = StringValidacao.copiarStringValida(nomeProcesso);
    }

    set SiglaProcesso(siglaProcesso: any) {
        this.siglaProcesso = StringValidacao.copiarStringValida(siglaProcesso);
    }

    parseFromJson(processo: any): void {
        this.IdProcesso = processo.idProcesso;
        this.NomeProcesso = processo.nomeProcesso;
        this.SiglaProcesso = processo.siglaProcesso;
    }

    copyObject(processo: Processo): void {
        this.IdProcesso = processo.idProcesso;
        this.NomeProcesso = processo.nomeProcesso;
        this.SiglaProcesso = processo.siglaProcesso;
    }

    modeloCompleto(): boolean {
        return this.nomeProcesso !== undefined && this.siglaProcesso !== undefined;
    }

    getNewInstance(object?: any): Processo {
        return new Processo(object);
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/processo.ts